import { render, staticRenderFns } from "./MemberRight.vue?vue&type=template&id=13610833&scoped=true"
import script from "./MemberRight.vue?vue&type=script&lang=js"
export * from "./MemberRight.vue?vue&type=script&lang=js"
import style0 from "./MemberRight.vue?vue&type=style&index=0&id=13610833&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13610833",
  null
  
)

export default component.exports